import { Container } from './styles'
export const CertificationCard = ({ src, alt }) => {
  return (
    <Container>
      <img src={ src } alt={ alt } />
    </Container>
  )
}